import { render, staticRenderFns } from "./AmwayPayCard.vue?vue&type=template&id=f9761a4c&scoped=true&"
import script from "./AmwayPayCard.vue?vue&type=script&lang=js&"
export * from "./AmwayPayCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9761a4c",
  null
  
)

export default component.exports